"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/RegisterToken");
var reactstrap_1 = require("reactstrap");
var ModalRegisterKeyTokenComponent = /** @class */ (function (_super) {
    __extends(ModalRegisterKeyTokenComponent, _super);
    function ModalRegisterKeyTokenComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true,
            isOpen: false,
            tokenName: "",
            tokenTime: 0,
            isSave: false,
            classSpinner: "d-none",
            version: 0
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.SaveClick = _this.SaveClick.bind(_this);
        _this.handleChangeTokenName = _this.handleChangeTokenName.bind(_this);
        _this.handleChangeTokenTime = _this.handleChangeTokenTime.bind(_this);
        return _this;
    }
    ModalRegisterKeyTokenComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen,
            isSave: false,
            classSpinner: "d-none",
            tokenName: ""
        });
    };
    ModalRegisterKeyTokenComponent.prototype.handleChangeTokenName = function (event) {
        this.setState({ tokenName: event.target.value });
    };
    ModalRegisterKeyTokenComponent.prototype.handleChangeTokenTime = function (event) {
        this.setState({ tokenTime: parseInt(event.target.value) });
    };
    ModalRegisterKeyTokenComponent.prototype.SaveClick = function () {
        this.setState({
            isSave: true,
            classSpinner: "d-inline-block"
        });
        this.props.requestFunction(this.props.appId, this.props.serviceId, this.state.tokenName, this.state.tokenTime, this.state.version);
    };
    ModalRegisterKeyTokenComponent.prototype.render = function () {
        //console.log("appId - " + this.props.appId);
        //console.log("serviceId - " + this.props.serviceId);
        if (this.props.isLoading && this.state.isSave && this.props.version > this.state.version) {
            this.toggleModal();
            this.props.setGetTokenTrue();
            this.setState({
                isSave: false,
                version: this.props.version
            });
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.toggleModal }, "Register Token"),
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen },
                React.createElement(reactstrap_1.ModalHeader, null, "Register Token"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("label", { htmlFor: "txtTokenName" },
                        React.createElement("b", null, "Token Name")),
                    React.createElement("input", { type: "text", id: "txtTokenName", className: "form-control", value: this.state.tokenName, onChange: this.handleChangeTokenName }),
                    React.createElement("label", { htmlFor: "txtTokenTime" },
                        React.createElement("b", null, "Token Time(Second)")),
                    React.createElement("input", { type: "number", id: "txtTokenTime", className: "form-control", value: this.state.tokenTime, onChange: this.handleChangeTokenTime })),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.SaveClick },
                        React.createElement(reactstrap_1.Spinner, { color: "primary", className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                        ' ',
                        "Save"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Cancel")))));
    };
    return ModalRegisterKeyTokenComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.registerTokenModel; }, Stores.actionCreators)(ModalRegisterKeyTokenComponent);
//# sourceMappingURL=ModalRegisterKeyTokenComponent.js.map